import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_2 = { class: "row col-md-7" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-7" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-7" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "row col-md-7" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "row col-md-7" }
const _hoisted_19 = { class: "el-input-group" }
const _hoisted_20 = {
  key: 1,
  class: "btn btn-loading",
  disabled: ""
}
const _hoisted_21 = { class: "page-content-info d-flex align-items-center justify-content-between" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[21] || (_cache[21] = _createElementVNode("h2", null, "Подписание сверка актов с 1С", -1)),
    (_ctx.hasAccess([..._ctx.findirRoles, ..._ctx.accountantRoles]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "accountingYear",
                class: "form-label col-md-3"
              }, "Расчетный год", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "2024",
                    step: "1",
                    class: "form-control",
                    id: "accountingYear",
                    required: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingYear) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.accountingYear]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "binList",
                class: "form-label col-md-3"
              }, "Список БИНов (пишите через запятую или один за другим)", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "binList",
                    cols: "30",
                    rows: "10",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.binList) = $event)),
                    placeholder: "1234567, 1234567, ...\nили\n1234567\n1234567\n..."
                  }, null, 512), [
                    [_vModelText, _ctx.binList]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                for: "kindergartenHeadSignStatus",
                class: "form-label col-md-3"
              }, "По статусу подписи директоров ДО", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kindergartenHeadSignStatus) = $event)),
                    id: "kindergartenHeadSignStatus",
                    class: "form-control"
                  }, _cache[9] || (_cache[9] = [
                    _createElementVNode("option", { value: "" }, "Выберите", -1),
                    _createElementVNode("option", { value: "NOT_SIGNED" }, "Не подписан", -1),
                    _createElementVNode("option", { value: "SIGNED" }, "Подписан", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.kindergartenHeadSignStatus]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                for: "findirSignStatus",
                class: "form-label col-md-3"
              }, "По статусу подписи фин. дир.", -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.findirSignStatus) = $event)),
                    id: "findirSignStatus",
                    class: "form-control"
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("option", { value: "" }, "Выберите", -1),
                    _createElementVNode("option", { value: "NOT_SIGNED" }, "Не подписан", -1),
                    _createElementVNode("option", { value: "SIGNED" }, "Подписан", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.findirSignStatus]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fetchKindergarten1CActReconciliationReports && _ctx.fetchKindergarten1CActReconciliationReports(...args)))
              }, "Поиск"),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-warning",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearSearchParam()))
                  }, "Сбросить фильтр"))
                : (_openBlock(), _createElementBlock("button", _hoisted_20, "Загрузка"))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createTextVNode("Найдено: ")),
        _createElementVNode("span", null, _toDisplayString(_ctx.totalCount), 1)
      ])
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.totalCount,
      "per-page": _ctx.pageSize
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.kindergarten1cActReconciliationReports,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#",
          width: "50"
        }),
        _createVNode(_component_el_table_column, { label: "Расчетный год" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.report.accountingYear), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "БИН" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.report.bin), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Название файла" }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.handleDownload(scope.row.report.uuid, scope.row.report.fileName)),
              class: _normalizeClass({ 'active-link': scope.row.report.reportStatus === 'GENERATED', 'error-link': scope.row.report.reportStatus === 'ERROR' })
            }, _toDisplayString(scope.row.report.fileName), 11, _hoisted_22)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Статус подписи директора ДО" }, {
          default: _withCtx((scope) => [
            (scope.row.kindergartenHeadSignStatus === 'SIGNED')
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Подписан " + _toDisplayString(scope.row.kindergartenHeadSignDateTime), 1))
              : (_ctx.hasAccess([..._ctx.kindergartenHeadRoles]) && scope.row.kindergartenHeadSignStatus === 'NOT_SIGNED')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (!_ctx.isSaving)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (_ctx.onClickSignDocument(scope.row.report.uuid))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" Подписать ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("Загрузка...")
                          ])),
                          _: 1
                        }))
                  ]))
                : (_ctx.hasAccess([..._ctx.findirRoles,..._ctx.accountantRoles]) && scope.row.kindergartenHeadSignStatus === 'NOT_SIGNED')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Не подписан "))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Статус проверки бухгалтера" }, {
          default: _withCtx((scope) => [
            (scope.row.hasAccountantChecked)
              ? (_openBlock(), _createBlock(_component_el_text, {
                  key: 0,
                  type: "success"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("Проверено")
                  ])),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_ctx.hasAccess([..._ctx.accountantRoles]))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "success",
                        plain: "",
                        loading: _ctx.isLoading,
                        onClick: ($event: any) => (_ctx.saveAccountantAccept(scope.row.id))
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("Проверено")
                        ])),
                        _: 2
                      }, 1032, ["loading", "onClick"]))
                    : (_openBlock(), _createBlock(_component_el_text, {
                        key: 1,
                        type: "info"
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("Не Проверено")
                        ])),
                        _: 1
                      }))
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Статус подписи Фин. Дир." }, {
          default: _withCtx((scope) => [
            (scope.row.finDirSignStatus === 'SIGNED')
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Подписан " + _toDisplayString(scope.row.finDirSignDateTime), 1))
              : (_ctx.hasAccess([..._ctx.findirRoles]) && scope.row.finDirSignStatus === 'NOT_SIGNED')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (!_ctx.isSaving)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (_ctx.onClickSignDocument(scope.row.report.uuid))
                        }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode(" Подписать ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode("Загрузка...")
                          ])),
                          _: 1
                        }))
                  ]))
                : (_ctx.hasAccess([..._ctx.kindergartenHeadRoles]) && scope.row.finDirSignStatus === 'NOT_SIGNED')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, " Не подписан "))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ]))
}